"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));

var _constants = require("../../constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _KeyboardReturn = _interopRequireDefault(require("@material-ui/icons/KeyboardReturn"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _makeStyles.default)(theme => ({
  searchBarContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  selectContainer: {
    maxWidth: 313
  },
  formControl: {
    display: 'flex',
    flex: 1
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  icon: {
    marginRight: theme.spacing(0.5)
  },
  inputContainer: {
    backgroundColor: _constants.colours.paleGrey,
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: theme.spacing(2)
  }
}));
const StyledInput = (0, _core.withStyles)(theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    background: _constants.colours.paleGrey,
    padding: theme.spacing(2),
    color: _constants.colours.font,
    fontFamily: _constants.fonts.book,
    fontSize: _constants.fontSizes.subtitle1,
    height: '100%',
    width: '100%'
  }
}))(_core.Input);
const StyledSelect = (0, _core.withStyles)(theme => ({
  root: {
    width: theme.spacing(29),
    height: theme.spacing(7),
    alignItems: 'center',
    display: 'flex',
    paddingLeft: theme.spacing(6),
    background: _constants.colours.paleGrey,
    borderRight: `solid 1px ${_constants.colours.inactiveState}`
  },
  filled: {
    color: _constants.colours.font,
    fontFamily: _constants.fonts.book,
    fontSize: _constants.fontSizes.subtitle1
  },
  iconFilled: {
    border: 0,
    color: _constants.colours.font,
    width: 36
  }
}))(_core.Select);
const StyledMenuItem = (0, _core.withStyles)(() => ({
  root: {
    '&:focus': {
      backgroundColor: _constants.colours.white,
      '&:hover': {
        backgroundColor: _constants.colours.lightGrey
      }
    },
    '&:hover': {
      color: _constants.colours.font,
      backgroundColor: _constants.colours.lightGrey
    },
    '&.Mui-selected': {
      backgroundColor: _constants.colours.multiSelect,
      color: _constants.colours.white
    },
    padding: '15px 19px'
  }
}))(_core.MenuItem);
const MenuProps = {
  PaperProps: {
    style: {
      borderRadius: 2,
      boxShadow: _constants.shadows.paperContainer
    }
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  getContentAnchorEl: null
};

const SearchBarDesktop = ({
  handleSelectChange,
  handleSubmit,
  handleInputChange,
  currentOption,
  currentSearchTerm,
  options
}) => {
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.searchBarContainer
  }, /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    variant: "filled",
    className: classes.selectContainer
  }, /*#__PURE__*/_react.default.createElement(StyledSelect, {
    value: currentOption,
    onChange: handleSelectChange,
    disableUnderline: true,
    IconComponent: _ExpandMore.default,
    variant: "filled",
    displayEmpty: true,
    MenuProps: MenuProps,
    renderValue: value => {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Search.default, {
        className: classes.icon,
        fontSize: "large",
        color: "primary"
      }), /*#__PURE__*/_react.default.createElement("span", null, value === '' ? 'Search by...' : options[value].label));
    }
  }, options.map((el, index) => {
    return /*#__PURE__*/_react.default.createElement(StyledMenuItem, {
      key: el.value,
      value: index
    }, el.label);
  }))), /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    variant: "filled",
    className: classes.inputContainer
  }, /*#__PURE__*/_react.default.createElement(StyledInput, {
    value: currentSearchTerm,
    disabled: currentOption === '',
    fullWidth: true,
    disableUnderline: true,
    placeholder: "Search...",
    onKeyDown: handleSubmit,
    onChange: handleInputChange
  }), /*#__PURE__*/_react.default.createElement(_KeyboardReturn.default, {
    className: classes.icon,
    fontSize: "small",
    color: "disabled"
  })));
};

SearchBarDesktop.propTypes = {
  handleSelectChange: _propTypes.default.func.isRequired,
  handleSubmit: _propTypes.default.func.isRequired,
  handleInputChange: _propTypes.default.func.isRequired,
  currentOption: _propTypes.default.string.isRequired,
  currentSearchTerm: _propTypes.default.string.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.object).isRequired
};

var _default = (0, _withWidth.default)()(SearchBarDesktop);

exports.default = _default;